<template>
    <svg
        class="ico icon fi"
        :class="extraClass"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.75"
        stroke-linecap="round"
        stroke-linejoin="round"
        :width="svgSize"
        :height="svgSize"
        :aria-hidden="labelled ? 'false' : 'true'"
        focusable="false"
        v-bind="svgAttrs"
        v-html="inner"
    />
</template>

<script>
    import { iconInner } from '../icons/admin-icons'

    export default {
        name: 'AdminIcon',
        inheritAttrs: false,
        props: {
            name: {
                type: String,
                default: 'default',
            },
            size: {
                type: [Number, String],
                default: null,
            },
        },
        computed: {
            inner() {
                return iconInner(this.name);
            },
            extraClass() {
                return this.$attrs.class || '';
            },
            svgSize() {
                return this.size || undefined;
            },
            labelled() {
                return !!(this.$attrs['aria-label'] || this.$attrs['aria-labelledby']);
            },
            svgAttrs() {
                const attrs = Object.assign({}, this.$attrs);
                delete attrs.class;
                return attrs;
            },
        },
    };
</script>
